import { all, call, put, takeEvery } from "redux-saga/effects";
import { actionTypes as propertiesActionTypes } from "./reducer";
import { getProperties, getBuildings, getUnits } from "./service";
import processAction from "../../utils/processAction";

function* getAllProperties(action) {
  yield processAction({
    ...action,
    service: getProperties,
    success: propertiesActionTypes.GET_PROPERTIES_SUCCESS,
    failed: propertiesActionTypes.GET_PROPERTIES_FAILED
  });
}

function* getAllBuildings(action) {
  yield processAction({
    ...action,
    service: getBuildings,
    success: propertiesActionTypes.GET_BUILDINGS_SUCCESS,
    failed: propertiesActionTypes.GET_BUILDINGS_FAILED
  });
}

function* getAllUnits(action) {
  const { params } = action;

  const params1 = Object.assign({}, params, { status: 1 });
  // const params2 = Object.assign({}, params, { status: 2 });
  // const params3 = Object.assign({}, params, { status: 3 });

  try {
    const [available] = yield all([
      call(getUnits, params1)
      // call(getUnits, params2)
      // call(getUnits, params3)
    ]);

    let payload = available;
    // [].concat(available).forEach(item => {
    //   let index = payload.findIndex(i => i.unit === item.unit);
    //   if (index === -1) {
    //     payload.push(item);
    //   }
    // });

    console.log("payloads", payload);

    // const payload = yield call(getUnits, params);

    yield put({
      type: propertiesActionTypes.GET_UNITS_SUCCESS,
      payload
    });
  } catch (error) {
    yield put({
      type: propertiesActionTypes.GET_UNITS_FAILED,
      error
    });
  }

  // yield processAction({
  //   ...action,
  //   service: getUnits,
  //   success: propertiesActionTypes.GET_UNITS_SUCCESS,
  //   failed: propertiesActionTypes.GET_UNITS_FAILED
  // });
}

function* watcher() {
  yield all([
    takeEvery(propertiesActionTypes.GET_PROPERTIES, getAllProperties),
    takeEvery(propertiesActionTypes.GET_BUILDINGS, getAllBuildings),
    takeEvery(propertiesActionTypes.GET_UNITS, getAllUnits)
  ]);
}

export default [watcher()];
